import api from '@/helpers/api'

const API_READ = `/api/client/transaction-history`

export default {
    namespaced: true,
    state: {
        status: '',
        history: [],
        errMessage: '',
        meta: {
            page: 1,
            limit: 10,
            total: 1
        },
        filter: {}
    },
    mutations: {
        request(state) {
            state.status = "Loading"
        },
        success(state) {
            state.status = "Success"
        },
        error(state, {message}) {
            state.status = "Error",
            state.errMessage = message
        },
        read(state, {history}) {
            state.history = [...history]
        },
        switch_page(state, {meta}) {
            state.meta = {...meta}
        },
        add_filter(state, { filter }) {
            state.filter = filter;
        },
    },
    actions: {
        read({commit, state}) {
            commit('request');

            const {meta} = state
            const { filter } = state
            
            return new Promise((resolve, reject) => {
                api.request('get', API_READ, { meta, filter })
                    .then((result) => {
                        // console.log(result.data.data);
                        const history = Array.isArray(result.data.data) ? result.data.data : [];
                        commit('success');
                        // commit('read', { history: result.data.data });
                        commit('read', { history });
                        commit('switch_page', { meta: {...result.data.meta} });

                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        }
    },
    getters: {
        history: () =>(state) => state.history,
    }
}